// removed by extract-text-webpack-plugin
module.exports = {"answerListTabsCard":"answerListTabsCard__3z9V6","answerListTabsCardOther":"answerListTabsCardOther__ZpDDJ","answerCount":"answerCount__m9Oog","ideaListCard":"ideaListCard__2v9iR"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Activity/ActivityParticipate.css
// module id = 1532
// module chunks = 0